import Vue from 'vue'
import VueSimpleAlert from "vue-simple-alert";
import VueBlobJsonCsv from "vue-blob-json-csv";
import VueWindowModal from "vue-window-modal";
import fs from "fs";
import Vuesax from 'vuesax'

import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)


Vue.use(VueWindowModal)
Vue.use(VueBlobJsonCsv)

Vue.use(VueSimpleAlert);
import App from './App.vue'
import router from './router'
import store from './store'
import './quasar'
import currencyToSymbolMap from 'currency-symbol-map/map'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faMobile } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faWindowClose } from '@fortawesome/free-solid-svg-icons'
import { faLineChart } from '@fortawesome/free-solid-svg-icons'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faComments } from '@fortawesome/free-solid-svg-icons'
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons'
import { faRectangleList } from '@fortawesome/free-solid-svg-icons'
import { faClipboardCheck } from '@fortawesome/free-solid-svg-icons'
import { faRectangleAd } from '@fortawesome/free-solid-svg-icons'
import { faChartLine } from '@fortawesome/free-solid-svg-icons'
import { faBarChart } from '@fortawesome/free-solid-svg-icons'
import { faPieChart } from '@fortawesome/free-solid-svg-icons'
import { faTools } from '@fortawesome/free-solid-svg-icons'
import { faSearchDollar } from '@fortawesome/free-solid-svg-icons'
import { faCircleDollarToSlot } from '@fortawesome/free-solid-svg-icons'
import { faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

const { GoogleSpreadsheet } = require('google-spreadsheet');

// loads document properties and worksheets
// gets all rows from the sheet

/* add icons to the library */
library.add(faEnvelope)
library.add(faLock)
library.add(faMobile)
library.add(faUser)
library.add(faBuilding)
library.add(faCircleCheck)
library.add(faExclamationCircle)
library.add(faLink)
library.add(faWindowClose)
library.add(faLineChart)
library.add(faShoppingCart)
library.add(faSearch)
library.add(faComments)
library.add(faBoxOpen)
library.add(faThumbsUp)
library.add(faRectangleList)
library.add(faClipboardCheck)
library.add(faRectangleAd)
library.add(faChartLine)
library.add(faBarChart)
library.add(faPieChart)
library.add(faTools)
library.add(faSearchDollar)
library.add(faCircleDollarToSlot)
library.add(faMoneyCheckAlt)
library.add(faChevronCircleRight)
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
Amplify.configure(aws_exports);


import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: '1020841759276-slim9bpm2ohr4sre7919sgh6pa25bq0u.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'consent',
  fetch_basic_profile: true
}
Vue.use(GAuth, gauthOption)

import mixpanel from 'mixpanel-browser';

mixpanel.init('01684628eba4fdf46200ec58ab18218b', {debug: true,track_pageview: true,persistence: 'localStorage'});

import VueCryptojs from 'vue-cryptojs'
Vue.use(VueCryptojs)
// Vue.use(VueMixpanel, {
//   token: '01684628eba4fdf46200ec58ab18218b',
//   config: {
//     debug: true
//   }
// })

Vue.prototype.$mixpanel = mixpanel;

import http from './http'
Vue.prototype.$http = http
import moment from 'moment'
Vue.prototype.$moment = moment
import VueCookies from 'vue-cookies'
Vue.use(VueCookies, { expire: '0' })
Vue.prototype.$org_id = Vue.observable({ label: '' })
Vue.prototype.$org_encryprt = Vue.observable({ label: '' })
Vue.prototype.$orgName = Vue.observable({ label: '' })
Vue.prototype.$top_level_orgid = Vue.observable({ label: '' })
Vue.prototype.$layoutInitialized = Vue.observable({ label: false })
Vue.prototype.$allorgList = Vue.observable({ list: [] })
Vue.prototype.$userVerified = Vue.observable({ label: false })
Vue.prototype.$notificationOn = Vue.observable({ label: '' })
const DEFAULT_TITLE = 'uniQin.ai';
router.afterEach((to, from) => {

  Vue.nextTick(() => {
    document.title = DEFAULT_TITLE;
  });
});


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
